// extracted by mini-css-extract-plugin
export default {"empty":"financial-information_empty__vOU0V"};